import React from "react";
import FnrOverlay, {
  FnrOverlayContents,
  FnrOverlayButtonRow,
  FnrOverlayTitle,
} from "UI/FnrOverlay";
import FnrButton from "UI/FnrButton3";
import { SharedResizingChild } from "UI/SharedResizingArea";

export default function PaymentMethodsUnsharedModal({ close }) {
  return (
    <FnrOverlay componentName="PaymentMethodsUnshared" autoShow>
      <>
        <FnrOverlayContents>
          <UnsharedMessageContent close={close} />
          <FnrOverlayButtonRow>
            <div />
            <FnrButton onClick={close} color="blue">
              Got it
            </FnrButton>
          </FnrOverlayButtonRow>
        </FnrOverlayContents>
      </>
    </FnrOverlay>
  );
}

export function UnsharedMessageContent({ close }) {
  return (
    <SharedResizingChild>
      <FnrOverlayTitle>Unsharing Payment Methods</FnrOverlayTitle>

      <div style={{ maxWidth: "300px" }}>
        <p>For your security, we have unshared your saved payment methods.</p>
        <p>To re-share, please visit the Wallet tab of your profile.</p>
      </div>
    </SharedResizingChild>
  );
}
